import ShopOrderItemModelBase from '../_generated/modelBases/shop-order-item-model-base';

export default class ShopOrderItemModel extends ShopOrderItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
